import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/header/header.component';
import { FooterComponent } from './core/footer/footer.component';
import { CabComponent } from './modules/cab/cab.component';
import { MainComponent } from './core/main/main.component';
import { MainService } from './core/main/main.service';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ViewYourTruckComponent } from './modules/view-your-truck/view-your-truck.component';
import { ErrorComponent } from './core/error/error.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BannerComponent } from './core/banner/banner.component';
import { CampaignComponent } from './modules/campaign/campaign.component';
import { StuartComponent } from './modules/stuart/stuart.component';
import { QuotationComponent } from './modules/quotation/quotation.component';
import { DocumentsComponent } from './modules/documents/documents.component';
import { MopinionComponent } from './core/mopinion/mopinion.component';
import { TranslationService } from './services/translation.service';
import { MarketingMaterialComponent } from './modules/marketing-material/marketing-material/marketing-material.component';
import { AnalyticsAttributeGateDirective } from './directives/analytics-attribute-gate.directive';
import { LanguageService } from './services/language.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    CabComponent,
    MainComponent,
    ViewYourTruckComponent,
    ErrorComponent,
    BannerComponent,
    CampaignComponent,
    StuartComponent,
    QuotationComponent,
    DocumentsComponent,
    MopinionComponent,
    MarketingMaterialComponent,
    AnalyticsAttributeGateDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationService,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    MainService,
    MainComponent,
    ErrorComponent,
    provideAppInitializer(() => {
      inject(LanguageService).initializeLanguage();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
